import styled from 'styled-components'

export const FloatingWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme: { layout } }) => layout.spacing(2)};
  padding: ${({ theme: { layout } }) => `${layout.spacing(2)} ${layout.spacing(3)}`};
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  background-color: rgba(255, 255, 255, 0.1);
`

export const ToggleButton = styled.button`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 50%;
  color: ${({ theme: { colors } }) => colors.textOpposite};
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.05);
  }
`

export type ToggleIconProps = {
  $isExpanded: boolean
}

export const ToggleIcon = styled.span<ToggleIconProps>`
  display: flex;
  transform: rotate(${({ $isExpanded }) => ($isExpanded ? 0 : 180)}deg);
  transition: transform 0.3s ease;
`

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  gap: ${({ theme: { layout } }) => layout.spacing(0.5)};
  overflow: hidden;
  font-size: 14px;
  white-space: nowrap;

  a {
    color: ${({ theme: { colors } }) => colors.textOpposite};
    text-decoration: none;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      width: 100%;
    }

    &:hover::after {
      border-color: transparent;
    }
  }
`
